export default {
  title: "DevXene",
  localPrefix: 'dxn',
  // NB: URL prefixes below must not end with a slash!
  baseURL: "https://devxene.cirii.org/api",
  storageURL: "https://devxene.cirii.org/storage",
};
